import React from "react";
import { useObserver } from "mobx-react";
import { Attachment } from "@material-ui/icons";
import { Body } from "@components";
import locale from "@bonliva-crm/locale";
import { DocumentList } from "@containers/DocumentList";
import { EmailEditorFormStore } from "./EmailEditorFormStore";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = {
  store: EmailEditorFormStore;
};

export function EmailEditorAttachmentList(props: Props) {
  const { store } = props;
  const classes = useStyles({});

  return useObserver(() => {
    if (!store.allowAttachments) {
      return null;
    }

    const message = (
      <div
        className={classes.empty}
        onClick={(e) => {
          e.stopPropagation();
          store.selectFiles();
        }}
      >
        <Attachment fontSize="small" />
        <Body color="inherit" style={{ textAlign: "center" }}>
          To attach a file click here or drag and drop it
          <br />
          Max. size of each attachment is 4 mb
        </Body>
      </div>
    );

    return (
      <div style={{ marginTop: 16 }}>
        {store.values.attachments.length > 0 && (
          <Body style={{ marginBottom: 8, paddingLeft: 4, fontWeight: 500 }}>
            {locale.Attachments}
          </Body>
        )}

        {store.values.attachments.length > 0 && (
          <DocumentList
            documents={store.values.attachments}
            onDelete={store.removeAttachment}
          />
        )}

        {message}
      </div>
    );
  });
}

const useStyles = makeStyles((theme: ThemeType) => ({
  empty: {
    alignItems: "center",
    color: theme.palette.text.secondary,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    padding: "8px 0 0",
    transition: theme.transitions.create("color"),

    "& svg": {
      marginRight: 8,
      color: theme.palette.text.secondary
    },

    "&:hover": {
      color: theme.palette.text.primary
    },

    "&:hover svg": {
      animation: "rubberBand .75s ease-in-out infinite both"
    }
  }
}));
